import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProjectFormsByType } from '../../services/getProjectFormsByType.service';

// Loads every page of one project form type. A 403 means the caller has no
// per-type access — that is resolved as "no access -> empty", not rethrown,
// so a folder the user cannot see simply loads as empty rather than erroring.
export const loadFormsByType = createAsyncThunk(
  'projectForm/loadFormsByType',
  async ({ projectId, type }) => {
    const forms = [];
    let nextToken = null;

    try {
      do {
        const response = await getProjectFormsByType({
          projectId,
          type,
          nextToken,
        });
        (response?.Items || []).forEach((form) => forms.push(form));
        nextToken = response?.nextToken || null;
      } while (nextToken);
    } catch (error) {
      if (error?.response?.status === 403) {
        return { projectId, type, forms: [], noAccess: true };
      }
      throw error;
    }

    return { projectId, type, forms };
  },
  {
    // Skip a type already loading/loaded, unless `force` is passed — a
    // forced reload still waits out a request already in flight rather than
    // piling a second one on top of it.
    condition: ({ type, force } = {}, { getState }) => {
      const status = getState().projectForms.formTypeStatus[type];

      if (force) {
        if (status === 'loading') {
          return false;
        }
        return;
      }

      if (status === 'loading' || status === 'loaded') {
        return false;
      }
    },
  }
);
